import React, {useState} from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import UploadGallery from "../../../components/uploadgallery/UploadGallery";
import UploadGalleryStore from "../../../components/uploadgallery/uploadGalleryStore";
import reviewBuilderUploadsApi from "../../../components/uploadgallery/reviewBuilderGalleryApi";

function ImageField({fieldObj, fieldIndex, fieldUpdatedFunction, singleLocationMode, readOnly}) {

    const [imageSelectorOpen, setImageSelectorOpen] = useState(false);
    const [uploadGalleryStore, setUploadGalleryStore] = useState(new UploadGalleryStore(reviewBuilderUploadsApi));
    const [url, setUrl] = useState(singleLocationMode || readOnly ? fieldObj.url : undefined)

    const unsetImageUrl = () => {
        fieldObj.url = ""
        setUrl("")
        fieldUpdatedFunction(fieldObj)
    }

    const setImageUrl = (theUrl) => {
        fieldObj.url = theUrl
        setUrl(theUrl)
        setImageSelectorOpen(false)
        fieldUpdatedFunction(fieldObj)
    }

    const indexKey = fieldObj.fieldId + fieldIndex;

    const isDisabled = () => {
        if (readOnly) {
            return true
        } else {
            singleLocationMode ? false : !fieldObj.bulkAllowed
        }
    }
    return (
        <div key={"div1-" + indexKey}>
            {!!url && <div className="col-12 col-sm-12">
                <div className="img-gallery-item">
                    <div className="text-center overflow-hidden">
                        <img src={url} style={{"height": "100px"}}/>
                    </div>
                    <div className="text-center" style={{"marginTop": "3px"}}>
                        <a onClick={unsetImageUrl} href="javascript:void(0)"
                           style={{textDecoration: 'underline'}}>{isDisabled() ? "" : "Remove"}</a>
                    </div>
                </div>
            </div>}
            {!url && <div className="col-12 col-sm-12">
                <div className="img-gallery-item">
                    <div className="text-center overflow-hidden border">
                        <div style={{"height": "45px", "width": "91px", "opacity": "0"}}/>
                        {/* Spacer to match height of uploaded images */}
                        <button disabled={isDisabled()} type="button" className="btn btn-secondary"
                                onClick={() => setImageSelectorOpen(true)}>
                            <i className="fa fa-plus"/>
                        </button>
                        <div style={{"height": "46px", "width": "91px", "opacity": "0"}}/>
                    </div>
                </div>
            </div>}
            {imageSelectorOpen && <Modal isOpen={true} toggle={() => setImageSelectorOpen(false)} className="modal-lg">
                <ModalHeader toggle={() => setImageSelectorOpen(false)}>Select or Upload an Image</ModalHeader>
                <ModalBody>
                    <UploadGallery uploadGalleryStore={uploadGalleryStore}
                                   imageSelectedCallback={image => setImageUrl(image.url)}/>
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-secondary"
                            onClick={() => setImageSelectorOpen(false)}>Cancel
                    </button>
                    {" "}
                </ModalFooter>
            </Modal>}
        </div>
    )

}

export default ImageField;